module.exports = __webpack_public_path__ + "static/media/question.160504fe.svg";